// src/components/HeroSlider.jsx
import { useEffect, useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HERO_SOURCES } from "../assets/utils/heroSources";

// Fisher–Yates shuffle
function shuffle(arr) {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

// `fill` renders the slider as a full-bleed background layer (position:absolute,
// no rounding, no built-in gradient) so a parent section can overlay its own
// scrim + content — matches the hero treatment on the How/Partner pages.
export default function HeroSlider({ intervalMs = 10000, aspect = "20/25", fill = false }) {
  const items = useMemo(() => shuffle(HERO_SOURCES), []);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!items.length) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % items.length), intervalMs);
    return () => clearInterval(id);
  }, [items.length, intervalMs]);

  if (!items.length) return null;
  const it = items[idx];

  return (
    <div
      className={fill ? "hero-slider hero-slider--fill" : "hero-slider"}
      style={fill ? undefined : { aspectRatio: aspect }}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={it.src}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 2 }}
          className="hero-slide"
          style={{
            backgroundImage: `url(${it.src})`,
            backgroundPosition: it.focal || "50% 50%",
          }}
          role="img"
          aria-label={it.alt || "Farm image"}
        />
      </AnimatePresence>
      {!fill && <div className="hero-gradient" aria-hidden="true" />}
    </div>
  );
}
